import { ArrowUpRight, Eye } from "lucide-react";
import type { LauncherApp } from "../lib/types";
import { AppIcon } from "./AppIcon";
import { Badge } from "./ui";

export function AppTile({ app }: { app: LauncherApp }) {
  return (
    <a
      href={app.launchUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="group relative flex min-h-[132px] flex-col rounded-xl border border-line bg-surface p-4 shadow-card transition-all hover:-translate-y-0.5 hover:border-accent/40 hover:shadow-pop focus-visible:-translate-y-0.5"
    >
      <div className="flex items-start justify-between gap-3">
        <AppIcon icon={app.icon} />
        <div className="flex items-center gap-1.5">
          {app.openItems > 0 && (
            <span
              className="inline-flex h-6 min-w-6 items-center justify-center rounded-full bg-accent px-1.5 text-[11.5px] font-semibold text-accent-fg"
              aria-label={`${app.openItems} items need attention`}
            >
              {app.openItems}
            </span>
          )}
          <ArrowUpRight className="size-4 text-subtle transition-colors group-hover:text-accent" aria-hidden />
        </div>
      </div>
      <p className="mt-3 text-[14.5px] font-semibold text-fg">{app.name}</p>
      <p className="mt-0.5 line-clamp-2 text-[12.5px] leading-relaxed text-muted">{app.description || app.category}</p>
      {app.accessLevel === "read_only" && (
        <Badge className="mt-2 self-start">
          <Eye className="size-3" aria-hidden /> View only
        </Badge>
      )}
      <span className="sr-only">(opens in a new tab)</span>
    </a>
  );
}
